document.addEventListener("alpine:init", () => {
    Alpine.data("progressiveAccordionSecondary", () => ({
        id: null,
        secondaryItems: null,
        init() {
            this.secondaryItems = this.$el.querySelectorAll(
                ".Pegasus__Container"
            );

            this.secondaryItems.forEach((element, index) => {
                if (index === 0) {
                    element.style.display = "";
                    this.id = element.id;
                } else {
                    element.style.display = "none";
                }
            });

            window.addEventListener("pegasus-pa-item-selected", (event) => {
                const { id, parent } = event.detail;
                
                // Find the closest accordion to this secondary container
                const parentContainer = this.$el.closest(".Pegasus__Container");
                const accordion = parentContainer?.querySelector(".Progressive__Accordion");

                // Only proceed if the event comes from the correct accordion
                if (!accordion || !accordion.contains(parent)) {
                    return;
                }

                this.id = id;

                this.secondaryItems.forEach((element) => {
                    element.style.display = this.id === element.id ? "" : "none";
                });
            });
        },
    }));
});
